import { FC } from "react";
import classNames from "classnames";
import { ButtonLoadingSpinnerProps } from "@/app/types/props/spinner/ButtonLoadingSpinner";

const spinnerStyles = {
  base: "w-5 h-5 border-2 border-t-transparent rounded-full animate-spin",
  colors: {
    light: "border-white",
    dark: "border-blue",
  },
};

export const ButtonLoadingSpinner: FC<ButtonLoadingSpinnerProps> = ({ variant }) => {
  const isLightVariant = ["primary", "danger"].includes(variant || "");

  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className={classNames(
          spinnerStyles.base,
          isLightVariant ? spinnerStyles.colors.light : spinnerStyles.colors.dark
        )}
      />
    </div>
  );
};
